import theme from "./theme.json";

type TokenValue = string | number | boolean | null | undefined;
interface TokenTree {
  [key: string]: TokenValue | TokenTree | TokenValue[];
}

function toKebabCase(value: string): string {
  return value.replace(/_/g, "-").replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}

function setCssVariable(name: string, value: TokenValue, root: HTMLElement) {
  if (value === null || value === undefined || value === false) {
    return;
  }

  root.style.setProperty(`--theme-${name}`, String(value));
}

function publishTokens(prefix: string, tokens: TokenTree, root: HTMLElement) {
  Object.entries(tokens).forEach(([key, value]) => {
    const variableName = prefix ? `${prefix}-${toKebabCase(key)}` : toKebabCase(key);

    if (Array.isArray(value)) {
      (value as TokenValue[]).forEach((item, index) => {
        setCssVariable(`${variableName}-${index + 1}`, item, root);
      });
      return;
    }

    if (value && typeof value === "object") {
      publishTokens(variableName, value as TokenTree, root);
      return;
    }

    setCssVariable(variableName, value, root);
  });
}

export function applyTheme(root = document.documentElement) {
  publishTokens("", theme as unknown as TokenTree, root);
}

export { theme };
